import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { create, use } from '@/config';
import '@/assets/iconfont/public/iconfont.css';
import 'swiper/dist/css/swiper.css';//这里注意具体看使用的版本是否需要引入样式，以及具体位置，此版本使用@4.5.1。
import '@/styles/css/index.css';
import '@/styles/css/niu-lang-en.css';
import '@/styles/less/antd.less';
import "ant-design-vue/dist/antd.less";

// 启动时按本地语言偏好挂上英文布局类（与 setLC 的 JSON 存储一致）
if (typeof document !== 'undefined') {
  try {
    const raw = localStorage.getItem('language');
    const lang = raw ? JSON.parse(raw) : null;
    if (lang === 'english') {
      document.documentElement.classList.add('niu-lang-en');
    }
  } catch (e) { /* ignore */ }
}

Vue.config.productionTip = false;

use(Vue);
create(Vue, router);

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
